import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=73aba34a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pexea12/repos/vue-image-lightbox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73aba34a')) {
      api.createRecord('73aba34a', component.options)
    } else {
      api.reload('73aba34a', component.options)
    }
    module.hot.accept("./LeftArrowIcon.vue?vue&type=template&id=73aba34a&", function () {
      api.rerender('73aba34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LeftArrowIcon.vue"
export default component.exports